import { memo } from "react";
import { NotificationBadge } from "@/shared/components/NotificationBadge";
import { useAdminNotificationsContext } from "@/shared/contexts/AdminNotificationsProvider";

/** Badge sidebar pour les réservations Locations en attente d'action
 * admin (workflow `pending_approval`). Iso pattern aux autres compteurs
 * de la sidebar (deals, refunds, communication). */
export const CatalogBookingsCounter = memo(() => {
  const { counts } = useAdminNotificationsContext();
  return <NotificationBadge count={counts.catalog_bookings_pending} />;
});

CatalogBookingsCounter.displayName = "CatalogBookingsCounter";
